<template>
  <div>
   <div class="container flash-message-top-container">
      <flash-message class="flash-message-top"></flash-message>
    </div>
    <div class="container container-admin text-center">
      <h3>{{title}}</h3>
      <nav class="navbar navbar-inverse navbar-cust">
          <ul class="nav navbar-nav">
            <li class="nav-item">
              <router-link class="nav-link" to="admin_comment_new">Add New <span class="sr-only">(current)</span></router-link> 
            </li>
          </ul>
      </nav>     
      <div class="list-row" v-for="com in this.listComments" v-bind:key="com._id">
          <div>
            <a href="#">{{com.title}}</a>
          </div>
        <div>
          <router-link class="nav-link" :to="{name: 'admin_comment_edit', params: {comment_id: com._id}}">Edit <span class="sr-only">(current)</span></router-link>
          <span>|</span>
          <button 
            type="button" 
            class="btn btn-link list-row-btn"
            v-confirm="{ok: () => { deleteComment(com._id); }, cancel: cancelDelete, message: 'Are you sure you want to remove comment ?'}" 
          >
            Delete
          </button> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDataFromServer } from "../../../utils/DataProvider";
  export default {
    data: () => {
      return{
         title: 'Comments',
         listComments: [],         
      }     
    },
    methods:{
      getCommentsList(){
        getDataFromServer('list_comments', null)
        .then(obj => 
        {
          console.log("response success : ", obj.data.success);
          if(obj.data.success === true){
            console.log("response list_comments: ", obj.data.data);              
            this.listComments = obj.data.data;          
          }
          else{
            this.flash('get comments error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {
          console.log("response : ", err);
           this.flash('get comments error: ' + err, 'error', {timeout: 4000})
        })
      },
      deleteComment(comId){        
        getDataFromServer('delete_comment', {id: comId})
        .then(obj => 
        {          
          if(obj.data.success === true){
            this.getCommentsList();
            this.flash('delete comment success ' , 'success', {timeout: 4000})                    
          }
          else{
            this.flash('delete comment error: ' + obj.data.text , 'error', {timeout: 4000})
          }
        })
        .catch(err => {
          console.log("response : ", err);
           this.flash('delete comment error: ' + err, 'error', {timeout: 4000})
        })
      },      
      cancelDelete(){
        this.flash('cancel delete comment ' , 'info', {timeout: 4000})
      },     
    },
    created(){
      this.getCommentsList();
    },
  }
</script>

<style scoped>

</style>
